// extracted by css-extract-rspack-plugin
export default {"identifierText":"use-mention-suggestions-module__identifierText__jkcWA"};